import { getAuthenticatedAccount } from "../../utils/accountUtils";

export const fetchHighestDocId = async (instance, accounts, setValue, tenantId) => {
  try {
    const account = await getAuthenticatedAccount(instance, accounts, tenantId);
    const response = await instance.acquireTokenSilent({
      scopes: [process.env.REACT_APP_AUTH_SP_SCOPE],
      account: account,
    });

    const graphApiUrl = process.env.REACT_APP_GRAPH_API_URL;
    const siteId = process.env.REACT_APP_SP_SITE_ID;
    const listId = process.env.REACT_APP_ENVIRONMENTAL_DOCUMENT_DATABASE_ID;

    const url = `${graphApiUrl}/sites/${siteId}/lists/${listId}/items/?$expand=fields($select=field_0)&$orderby=fields/field_0 desc&$top=1`;

    const result = await fetch(url, {
      headers: {
        Authorization: `Bearer ${response.accessToken}`,
        "Content-Type": "application/json",
      },
    });

    const data = await result.json();

    if (data.value && data.value.length > 0) {
      const highestDocId = data.value[0].fields.field_0;
      
      const nextDocId = (parseInt(highestDocId) + 1).toString();
      setValue("docId", nextDocId);
    } else {
      setValue("docId", "1");
    }
  } catch (error) {
    console.error("Error fetching highest DOCID:", error);
    throw error;
  }
}; 